export default __webpack_public_path__ + "static/media/down-1.51c94536.svg";